import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { attendanceApi, Util } from "../../services";
import TeamAttendance from "./teamAttendance";
import { Card } from "primereact/card";
import MissingAttendance from "./missingAttendance";
import MissingLeave from "./missingLeave";
import moment from "moment";
import { doAttandence } from "../../services/common/states";
import { hasPermission, ProtectedSection } from '../../components/protected/ProtectedSection';
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import './style.scss';
import { BULK_ATTENDENCE } from '../../config/permissions';
import { utitService } from '../../services/util';
import { useSelector } from "react-redux";
function Attendance() {
  const { user } = useSelector(state => state.user);
  const [selectedTab, setSelectedTab] = useState(0);
  const [userAttendanceList, setUserAttendanceList] = useState([]);
  const [inTime, setInTime] = useState("-- -- --");
  const [outTime, setOutTime] = useState("-- -- --");
  const [inDate, setInDate] = useState("-- -- ----");
  const [dateOut, setDateOut] = useState("-- -- --");
  const [createAttendance, setCreateAttendance] = useState(true);
  const [employeeType, setEmployeeType] = useState(true);
  const { search } = useLocation();
  const [dialogVisible, setDialogVisible] = useState(false);
  const [startTime, setStartTime] = useState('');
  const [checked, setChecked] = useState(false);
  const [workMode, setWorkMode] = useState('WFO'); // Default value
  const urlActions = new URLSearchParams(search).get("action");
  let currentUser = JSON.parse(localStorage.getItem("user"));
  const findEmpType = () => {
    if (currentUser.roles[0] === "employee") {
      setEmployeeType(false);
    }
  };
  let count = 0;
  useEffect(() => {
    if (urlActions === "app") {
      setSelectedTab(1);
    } else if (urlActions === "reg" && currentUser.roles[0] === "employee") {
      setSelectedTab(2);
    } else if (urlActions === "reg" && currentUser.roles[0] !== "employee") {
      setSelectedTab(1);
    } else {
      setSelectedTab(0);
    }
    findEmpType();
    if (count == 0) {
      // if (hasPermission(TIMESHEET_INVOICE_VIEW)) {
      doAttandence.subscribe((result) => {
        if (result) {
          fetchAttendanceData(result);
        }
      });
      // }
      count++;
    }
    getPayslipData();
  }, []);


  const getPayslipData = () => {
    attendanceApi.getUserPaySlip().then((resp) => {
      console.log(resp.data, "<<<getPayslipData>>>")
    });
  }

  const fetchAttendanceData = (result) => {
    let currDate = moment(new Date()).format("YYYY-MM-DD");
    try {
      let attendanceData = result.filter((e) => { return e.status === 1 || e.status === 0 || e.status === 2 })
      setUserAttendanceList(attendanceData);
      let dateCheck = result.filter((el) => {
        return el.date == currDate;
      });
      const reqData = dateCheck[0];
      if (reqData) {
        var inDateTime = reqData.inTime.split("T");
        let inTime = Util.getTimeFromDate(Util.convertTZ(inDateTime, ""));
        if (reqData.outTime) {
          var outDateTime = reqData.outTime.split("T");
          let outTime = Util.getTimeFromDate(Util.convertTZ(outDateTime, ""));
          setOutTime(outTime);
          setDateOut(outDateTime[0]);
        } else {
          setOutTime("-- -- --");
          setDateOut("-- -- --");
        }
        setInTime(inTime);
        setInDate(inDateTime[0]);
      }
    } catch (error) {
      // Error handle
    }
  };

  const fetchUserAttendanceData = () => {
    attendanceApi.getAllAttendance().then((resp) => {
      let currDate = moment(new Date()).format("YYYY-MM-DD");
      try {
        let attendanceData = resp.data.data.filter((e) => {
          return e.status === 1 || e.status === 0 || e.status === 2
        })
        setUserAttendanceList(attendanceData);
        let dateCheck = resp.data.data.filter((el) => {
          return el.date == currDate;
        });
        const reqData = dateCheck[0];
        if (reqData) {
          var inDateTime = reqData.inTime.split("T");
          let inTime = Util.getTimeFromDate(Util.convertTZ(inDateTime, ""));
          if (reqData.outTime) {
            var outDateTime = reqData.outTime.split("T");
            let outTime = Util.getTimeFromDate(Util.convertTZ(outDateTime, ""));
            setOutTime(outTime);
            setDateOut(outDateTime[0]);
          } else {
            setOutTime("-- -- --");
            setDateOut("-- -- --");
          }
          setInTime(inTime);
          setInDate(inDateTime[0]);
        }
      } catch (error) {
        // Error handle
      }
    });
  };

  const onChangeTab = (e) => {
    setSelectedTab(e?.index);
    if (e.index === 0) {
      fetchUserAttendanceData();
    }
  };

  const cardTemplate = () => {
    return (
      <div className="grid">
        <div className="col-fixed" style={{ width: '280px' }}>
          <Card title="In Time" subTitle="" footer={footer} header={header} className="md:w-20rem" style={{ background: "#F2F6F9" }}></Card>
        </div>
        <div className="col-fixed" style={{ width: '280px' }}>
          <Card title="Out Time" subTitle="" footer={footer1} header={header1} className="md:w-20rem" style={{ background: "#FDF6F4" }}></Card>
        </div>
        <ProtectedSection permissions={[BULK_ATTENDENCE]}>
          <div className="col-fixed" style={{ width: '280px' }}>
            <Card title={createAttendance ? "Management Attendance" : ""} header={header2} className="md:w-20rem bulk-card">
              <div style={{ textAlign: "center" }}>
                <Button onClick={() => setDialogVisible(true)} className="p-button p-button-warning p-button-sm mt-5" label="Create" />
              </div>
            </Card>
          </div>
        </ProtectedSection>
        <div className="col">

        </div>
      </div>
    );
  };

  const header = (
    <div className="" style={{ width: "50px", paddingTop: "20px" }}>
      <div className="container" style={{ color: "black", width: "38px", borderRadius: "20%", left: "21px", display: "block", textAlign: "center", fontSize: "22px", fontWeight: "600", backgroundColor: "#124d91", marginLeft: "12px", paddingTop: "6px", height: "38px", }}>
        <img style={{ height: "20px", width: "20px" }} src={`${process.env.PUBLIC_URL}/assets/images/In.svg`}></img>
      </div>
    </div>
  );

  const header1 = (
    <div className="" style={{ width: "60px", paddingTop: "8px" }}>
      <div className="container" style={{ color: "black", width: "52px", bottom: "0px", left: "21px", display: "block", textAlign: "center", fontSize: "22px", fontWeight: "600", marginLeft: "12px", paddingTop: "5px", height: "50px", }}>
        <img src={`${process.env.PUBLIC_URL}/assets/images/out.svg`}></img>
      </div>
    </div>
  );

  const header2 = (
    <div className="" style={{ width: "60px", paddingTop: "8px" }}>
      <div className="container" style={{ color: "black", width: "52px", bottom: "0px", left: "21px", display: "block", textAlign: "center", fontSize: "22px", fontWeight: "600", marginLeft: "12px", paddingTop: "5px", height: "50px", }}>
        <i className="pi pi-user bulk-card-icon"></i>    </div>
    </div>
  );

  const footer = (
    <div className="flex flex-wrap justify-content gap-2">
      <p>
        <b style={{ fontSize: "24px" }}>{inTime}</b> ({inDate})
      </p>
    </div>
  );
  const footer1 = (
    <div className="flex flex-wrap justify-content gap-2">
      <p>
        <b style={{ fontSize: "24px" }}>{outTime}</b> ({dateOut})
      </p>
    </div>
  );

  const fetchStatus = (status, isWeekOff, isOnLeave, isClientHoliday, isRegularize, isCompOff) => {
    if (status === 0) return (<div style={{ color: "#cb7205" }}>PARTIAL MARKIN</div>);
    if (status === 1 && !isWeekOff && !isOnLeave && !isClientHoliday && !isRegularize) return (<div style={{ color: "#a8328d" }}>COMPLETED</div>);
    if (status === 1 && isRegularize && !isWeekOff && !isCompOff) return (<div style={{ color: "#008000" }}>APPROVED</div>);
    if (status === 1 && isClientHoliday) return (<div style={{ color: "#eb34a5" }}>HOLIDAY</div>);
    if (status === 1 && isWeekOff && isRegularize) return (<div style={{ color: "#32a8a8" }}>WEEKOFF/APPROVED</div>);
    if (status === 1 && isCompOff && isRegularize) return (<div style={{ color: "#ff0080" }}>COMPOFF/APPROVED</div>);
    if (status === 2) return (<div style={{ color: "red" }}>LEAVE</div>);
  };

  const statusBodyTemplate = (data) => {
    return (
      <span style={{ borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status, data.isWeekOff, data.isOnLeave, data.isClientHoliday, data.isRegularize, data.isCompOff)}</span>
    );
  };
  const reviewActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" tooltip="Delete Attendance" tooltipOptions={{ position: "top" }} onClick={(e) => deleteCompleteAttendance(e, rowData)} />
      </React.Fragment>

    )
  }
  const deleteCompleteAttendance = (e, rowData) => {
    confirmDialog({
      target: e.currentTarget,
      message: 'Are you sure you want to delete this attendance?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptClassName: "p-button-danger",
      acceptLabel: 'No',
      rejectLabel: 'Yes',
      reject: () => {
        let param = {
          Ids: [rowData.id],
        };
        try {
          attendanceApi.deletemutipleAttendance(param).then((resp) => {
            toast.success("Record deleted successfully");
            fetchUserAttendanceData();
          })
        } catch (error) {

        }
      },
      accept: () => { }
    });
  }


  const handleCreate = () => {
    if (!startDates || !endDate) {
      toast.error('You must select both start date and end date.');
      return;
    }
    const currentDate = moment().startOf('day');
    const selectedStartDate = moment(startDates).startOf('day').set({ hour: 9, minute: 0 });
    const selectedEndDate = moment(endDate).startOf('day').set({ hour: 18, minute: 0 });
    if (selectedStartDate.isAfter(currentDate) || selectedEndDate.isAfter(currentDate)) {
      toast.error('You cannot create attendance for future dates.');
      return;
    }
    const param = {
      startDate: startDates.toISOString(),
      endDate: endDate.toISOString(),
      location: workMode,
      inTime: startDates.toISOString(),
      outTime: endDate.toISOString(),
    };
    attendanceApi.createMultipleAttendance(param)
      .then((resp) => {
        if (resp.data.success) {
          setDialogVisible(false);
          fetchUserAttendanceData();
          toast.success('Attendance created successfully.');
        } else {
          toast.error('Attendance already created for the day');
        }
      })
      .catch((error) => {
        console.error('Error creating attendance:', error);
        toast.error(error?.response?.data?.error);
      });
  };

  const handleReset = () => {
    setStartDates(null);
    setEndDate(null);
    setStartTime('');
  };

  const [startDates, setStartDates] = useState(() => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    currentDate.setHours(9, 0, 0, 0);
    return currentDate;
  });
  const handleStartDateChange = (event) => {
    setStartDates(event.value);
  };

  const [endDate, setEndDate] = useState(() => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    currentDate.setHours(18, 0, 0, 0);
    return currentDate;
  });
  const handleToDateChange = (event) => {
    setEndDate(event.value)
  };

  return (
    <div className="ess-page">
      <div className="card" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
        {selectedTab === 0 ? cardTemplate() : ""}
      </div>
      <div className="ess-table">
        <TabView activeIndex={selectedTab} onTabChange={(e) => { onChangeTab(e); }}>
          <TabPanel header="My Attendance">
            <DataTable
              value={userAttendanceList}
              tableStyle={{ minWidth: "50rem" }}
              paginator
              responsiveLayout="scroll"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
              dataKey="id"
            >
              <Column field="date" header="Date" bodyStyle={(r) => utitService.dateParser(r.date)} ></Column>
              <Column field="inTime" body={(r) => utitService.dateParser(r.date, 'dddd')} header="Day" ></Column>
              <Column field="inTime" body={(row) => utitService.dateParser(row.inTime, 'hh:mm:ss A (DD-MM-YYYY)')} header="In Time" ></Column>
              <Column field="outTime" body={(row) => utitService.dateParser(row.outTime, 'hh:mm:ss A (DD-MM-YYYY)')} header="Out Time"></Column>
              <Column field="" body={Util.workingHoursDff} header="Total Time"></Column>
              <Column field="location" header="Location"></Column>
              <Column field="" header="Status" body={statusBodyTemplate}></Column>
              <Column field="" header="Action" body={reviewActionBodyTemplate} bodyStyle={{ width: '60px' }}></Column>
            </DataTable>
          </TabPanel>
          {employeeType && (
            <TabPanel header="Team Attendance">
              <TeamAttendance />
            </TabPanel>
          )}
          <TabPanel header="Missing Attendance">
            <MissingAttendance></MissingAttendance>
          </TabPanel>
          {user?.LegalEntity?.code === 'ESIN' && (
            <TabPanel header="Missing Leaves">
              <MissingLeave></MissingLeave>
            </TabPanel>
          )}
        </TabView>
      </div>
      <Dialog
        header="Add Attendance"
        className="attend_popup"
        visible={dialogVisible}
        onHide={() => setDialogVisible(false)}
        modal
        footer={(
          <div className="p-grid p-justify-between">
            <Button onClick={handleReset} className="p-button p-button-secondary" label="Reset" />
            <Button onClick={handleCreate} className="p-button" label="Submit" />
          </div>
        )}
      >
        <div className="p-grid p-fluid">
          <div className="p-col-6" >
            <div className="p-field" style={{ marginBottom: '20px' }}>
              <label style={{ fontSize: '16px' }}>From Date</label>
              <Calendar
                value={startDates}
                onChange={handleStartDateChange}
                dateFormat="dd/mm/yy"
                showTime
                showIcon
                hourFormat="12"
                placeholder="From Date"
                appendTo={document.body}
              />
            </div>
          </div>
          <div className="p-col-6" >
            <div className="p-field" style={{ marginBottom: '20px' }}>
              <label style={{ fontSize: '16px' }}>To Date :</label>


              <Calendar
                value={endDate}
                onChange={handleToDateChange}
                dateFormat="dd/mm/yy"
                showTime
                showIcon
                hourFormat="12"
                placeholder="From Date"
                appendTo={document.body}
                minDate={startDates}
                disabled={!startDates}
              />
            </div>
          </div>
          <div className="p-col-12 p-field-checkbox" style={{ textAlign: 'center', marginTop: '10px' }}>
            <label style={{ fontSize: '16px' }}>Work Mode:</label>
            <div className="p-field" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ marginRight: '10px' }}>WFO</span>
              <InputSwitch
                checked={workMode === 'WFH'}
                onChange={(e) => setWorkMode(e.value ? 'WFH' : 'WFO')}
                onIcon="pi pi-calendar"
                onLabel=""
                offLabel=""
              />
              <span style={{ marginLeft: '10px' }}>WFH</span>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
export default Attendance;